<template>
  <el-drawer
    v-model="showDrawer"
    ref="roomTypeDrawer"
    custom-class="r-drawer"
    @close="handleClose"
  >
    <template #title>
      <div class="font-18 font-bold color-black">房型筛选</div>
    </template>

    <div class="list-container">
      <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange">全部</el-checkbox>
      <el-checkbox-group class="flex-col" v-model="checkedRoomTypes" @change="handleCheckedRoomTypsChange">
        <el-checkbox v-for="type in typeList" :key="type.id" :label="type.id">{{ type.roomTypeName }}</el-checkbox>
      </el-checkbox-group>
    </div>
  </el-drawer>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    typeList: {
      type: Array,
      default: () => ([])
    },
    selList: {
      type: Array,
      default: () => ([])
    }
  },
  emits: [ 'change' ],
  data() {
    return {
      checkAll: false,
      isIndeterminate: false,
      checkedRoomTypes: [],

      showDrawer: false,
    };
  },
  created() {
    this.showDrawer = this.value;
  },
  watch: {
    value(val) {
      this.showDrawer = val;
    },
    selList: {
      deep: true,
      handler(val) {
        this.checkedRoomTypes = val || []
      }
    }
  },
  methods: {
    // 处理点击全选
    handleCheckAllChange(val) {
      this.checkedRoomTypes = val ? this.typeList.map(item => item.id) : []
      this.isIndeterminate = false
    },
    // 处理点击单选
    handleCheckedRoomTypsChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.typeList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.typeList.length
    },
    // 处理关闭弹层
    handleClose() {
      this.$emit("input", false);
      this.$emit("change", this.checkedRoomTypes)
      this.$refs.roomTypeDrawer.handleClose();
    },
  },
};
</script>

<style lang="less" scoped>
.list-container {
  max-height: 100%;
  overflow: auto;
}
.flex-col {
  display: flex;
  flex-direction: column;
}
</style>